import { useLanguageContext } from "../../../../context/LanguageContext";
import FieldOptionPage from "../../../../pages/fields/field/option/FieldOptionPage";
import { useFieldEditRouteValidator } from "../../../validators/fields/FieldEditRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useFieldEditRouteConfig from "../FieldEditRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useFieldOptionCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/fields/:field/options/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.field_option"),
        },
      ])
    )
    .setValidator(useFieldEditRouteValidator())
    .setPage(<FieldOptionPage />)
    .setParent(useFieldEditRouteConfig());
}

export default useFieldOptionCreateRouteConfig;
